import { IEfcsState } from '../../models';

export const efcsState: IEfcsState = {
  efcs: [],
};
